import { APP_NOTIFICATION_SHOWN, APP_OPTIONS_SET, THEME_FIELD_BLURRED, THEME_FIELD_FOCUSED, UPDATE_BREAKPOINT, SET_IS_PRESET_PANEL_OPEN } from './ActionTypes';
import { getActiveThemePresetId } from '../selectors/themeSettingsSelectors';
export const setOptions = options => {
  return {
    type: APP_OPTIONS_SET,
    payload: options
  };
};
export const showNotification = notification => {
  return {
    type: APP_NOTIFICATION_SHOWN,
    meta: {
      notification
    }
  };
};
export const focusField = fieldKey => {
  return {
    type: THEME_FIELD_FOCUSED,
    payload: {
      fieldKey
    }
  };
};
export const blurField = fieldKey => {
  return {
    type: THEME_FIELD_BLURRED,
    payload: {
      fieldKey
    }
  };
};
export const updateBreakpoint = breakpointName => {
  return {
    type: UPDATE_BREAKPOINT,
    payload: {
      breakpointName
    }
  };
};
export const setIsPresetPanelOpen = isPresetPanelOpen => {
  return (dispatch, getState) => {
    const activeThemePresetId = getActiveThemePresetId(getState());
    dispatch({
      type: SET_IS_PRESET_PANEL_OPEN,
      payload: {
        isPresetPanelOpen,
        activeThemePresetId
      }
    });
  };
};